import React from 'react';
import OrderLedgerPage from '../Accountant/OrderLedgerPage';

/** Order ledger inside Master Admin layout (uses same accountant APIs as MA-authenticated user). */
const MaOrderLedgerPage: React.FC = () => <OrderLedgerPage />;

export default MaOrderLedgerPage;
